import Route from "vue-routisan";
import isAuthenticated from "./middlewares/isAuthenticated";
import isTaker from "./middlewares/isTaker";
import hasFinancierPermission from "@/http/routes/middlewares/hasPermission/hasFinancierPermission";

const options = {
  meta: {
    layout: () => import(/* webpackChunkName: "transporter" */ "@/resources/views/finance/taker/layout/Layout.vue")
  }
};

Route.group({}, () => {
  Route.group({prefix: "finance", beforeEnter: [isAuthenticated, hasFinancierPermission]}, () => {
    Route.group({beforeEnter: isTaker}, () => {

      Route.redirect("/", to => {
        return {name: "finance"};
      });

      Route.view("/home", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationHome")
      ).name("finance").options(options);

      Route.view("/panel_notification", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/panel/PanelNotificationFinanceList")
      ).name("finance.panel_notification").options(options);

      Route.view("/profile", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/new/taker/TakerProfileOverview.vue")
      ).name("finance.profile").options(options);

      Route.view("/documents", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationDocuments")
      ).name("finance.quotation_documents").options(options);

      Route.group({prefix: "users"}, () => {
        Route.view("/", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/user/UserList")
        ).name("finance.users").options(options);
        Route.view("/create", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/user/UserCreate")
        ).name("finance.user_create").options(options);
        Route.view("/update/:id", () =>
          import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/user/UserUpdate")
        ).name("finance.user_update").options(options);
      });

      Route.view("/quotations", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationList")
      ).name("finance.quotations").options(options);

      Route.view("/create", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationCreate.vue")
      ).name("finance.quotation_create").options(options);

      Route.view("/construct/:id", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationConstruct")
      ).name("finance.quotation_construct").options(options);

      Route.view("/details/:id", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/QuotationDetails")
      ).name("finance.quotation_details").options(options);

      Route.view("/quotation/details/:quotation_id/:bank_id", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/quotation/solicitation/QuotationSolicitationDetails.vue")
      ).name("finance.quotation_solicitation_details").options(options);

      Route.view("/anticipation", () =>
        import(/* webpackChunkName: "transporter" */ "src/resources/views/finance/taker/anticipation/AnticipationDocumentList")
      ).name("finance.anticipation_documents").options(options);
    });

  });
});

export default Route.all();
